import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { api } from "@/lib/api";

export default function Blog() {
  const { T, lang } = useLanguage();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get(`/public/blog?lang=${lang}`).then((r) => setPosts(r.data)).catch(() => {});
  }, [lang]);

  return (
    <div className="pt-16 pb-10 px-6 lg:px-16 max-w-[1200px] mx-auto" data-testid="blog-page">
      <div className="mb-16 max-w-lg">
        <p className="text-[11px] tracking-[0.25em] uppercase text-[#9B6179] mb-3">{T.blog.eyebrow}</p>
        <h1 className="font-serif text-4xl lg:text-5xl text-[#9B6179] mb-4">{T.blog.title}</h1>
        <p className="text-base text-[#090708]/55">{T.blog.subtitle}</p>
      </div>

      <div className="flex flex-col divide-y divide-[#090708]/8">
        {posts.map((p, i) => (
          <Link key={p.id} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group grid grid-cols-1 md:grid-cols-12 gap-6 items-center py-8 hover:bg-[#9B6179]/5 transition-colors duration-500">
            <span className="hidden md:block md:col-span-1 font-serif text-sm text-[#E8C47A]">{String(i + 1).padStart(2, "0")}</span>
            <div className="md:col-span-3 h-32 overflow-hidden">
              <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="md:col-span-6">
              <p className="text-[10px] tracking-widest uppercase text-[#9B6179] mb-1">{p.category}</p>
              <p className="font-serif text-2xl text-[#090708] mb-1">{p.title}</p>
              <p className="text-sm text-[#090708]/50 line-clamp-1">{p.excerpt}</p>
            </div>
            <span className="md:col-span-2 justify-self-start md:justify-self-end inline-flex items-center gap-2 text-[11px] tracking-[0.2em] uppercase text-[#090708]">
              {T.blog.read_more} <ArrowUpRight className="w-3.5 h-3.5" />
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
